import { Link, useLocation } from "react-router-dom";
import ReactTooltip from "react-tooltip";
const SidebarButton = ({
  icon,
  setActiveBtn,
  path,
  sideToggle,
  headerToggle,
  title,
  type,
}) => {
  const router = useLocation();
  return (
    <Link to={path}>
      {sideToggle && (
        <ReactTooltip place="right" effect="solid" backgroundColor="#25bdf9" />
      )}
      <button
        data-tip={title}
        onClick={() => {
          setActiveBtn(title);
        }}
        className={` flex shrink-0 items-center group text-sm sm:text-base   ${
          !sideToggle ? "px-6 space-x-5" : "justify-center"
        } ${router.pathname === path && "bg-primary/50"} h-[50px] w-full ${
          type === "main"
            ? "bg-header/60  hover:bg-primary/20"
            : " hover:bg-primary/20 "
        }  transition-all duration-300 ease-out`}
      >
        {icon}
        <span
          className={`${
            (sideToggle || headerToggle) &&
            " absolute opacity-0 invisible transition-none"
          }  transition-all duration-500 ease-out whitespace-nowrap`}
        >
          {title}
        </span>
      </button>
    </Link>
  );
};

export default SidebarButton;
